module.exports = __webpack_public_path__ + "img/gracie.c9a693f2.png";